import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { OnboardingStage } from '../models';
import { Coverage3dOnboardingDeviceBehaviorService } from '../services';

@Pipe({
	name: 'onboardingStageTitle',
	standalone: true
})
export class OnboardingStageTitlePipe implements PipeTransform {
	private readonly transloco = inject(TranslocoService);
	private readonly deviceBehavior = inject(Coverage3dOnboardingDeviceBehaviorService);

	public transform(stage: OnboardingStage, model: DeviceModel): string {
		// Prioritize the device-specific title if available
		const title = this.deviceBehavior.getStageTitle(model, stage);
		if (title) {
			return title;
		}
		// Apply default titles based on the stage if no device-specific title is available
		switch (stage) {
			case OnboardingStage.Introduction:
				return this.transloco.translate('scCoverage3dOnboarding.onboarding-stages.introduction.title', {
					deviceModel: model
				});
			case OnboardingStage.Completed:
				return this.transloco.translate('scCoverage3dOnboarding.onboarding-stages.completed.title');
			default:
				return '';
		}
	}
}
